module.exports = __webpack_public_path__ + "static/media/Interstate-Bold.f4d7df6f.otf";